import { useState, useEffect, useContext, useCallback, useRef } from "react";
import { Link } from "react-router-dom";

import toast from "react-hot-toast";
import lightenColor from "../lightenColor";

import { useHttpClient } from "../../../../../shared/hooks/http-hook";
import { AuthContext } from "../../../../../shared/context/auth-context";
import { ClinicaContext } from "../../../../../shared/context/clinica-context";
import SeletorUnidadeDados, {
  TODAS_UNIDADES,
} from "../../../../../shared/components/badgeUnidade/SeletorUnidadeDados";
import BadgeUnidade from "../../../../../shared/components/badgeUnidade/BadgeUnidade";
import BadgeCobertura from "../../../../../shared/components/badgeCobertura/BadgeCobertura";
import {
  paramsUnidadeDados,
  queryUnidadeDados,
  podeAlterarRegisto,
  motivoBloqueioUnidade,
  nomeUnidadeEscolhida,
} from "../../../../../shared/util/unidadeRegisto";
import { ptBR } from "date-fns/locale";

//MUI TABLE
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";

//MUI MODAL
import Box from "@mui/material/Box";
//

//Mui button dropdown
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
//

//Mui Select data
//MUI
import TextField from "@mui/material/TextField";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import { format, addDays, subDays, startOfDay, endOfDay } from "date-fns";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";

// Importações adicionais para o multiselect
import Select from "@mui/material/Select";
import OutlinedInput from "@mui/material/OutlinedInput";
import Checkbox from "@mui/material/Checkbox";
import ListItemText from "@mui/material/ListItemText";
import Chip from "@mui/material/Chip";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";

import { useLoading } from "../../../../../shared/context/LoadingContext";
import "./MarcacoesSecretaria.scss";

import { useWebSocketSubscription } from "../../../../../shared/context/websocket-context";

import { abreviarNome } from "../../../../../shared/util/helperFunctions";
import ObservacoesAgendamentoTooltip from "../../../components/observacoesAgendamentoTooltirp/ObservacoesAgendamentoTooltip";

import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import TextareaAutosize from "@mui/material/TextareaAutosize";
import SmsIcon from "@mui/icons-material/Sms";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import HourglassEmptyIcon from "@mui/icons-material/HourglassEmpty";

import { useSmsLembretes, SMS_ATIVO } from "./useSmsLembretes";
import {
  ehDeDiaFuturo,
  textoConfirmacao,
  diaEmVista,
} from "./confirmacaoPresenca";

const MOTIVOS_FALTA = [
  "AGENDAMENTO_CANCELADO",
  "CONDICAO_CLIMATICA",
  "DOENCA",
  "EMERGENCIA_FAMILIAR",
  "ESQUECIMENTO",
  "MELHORA_DOS_SINTOMAS",
  "PROBLEMAS_FINANCEIROS",
  "SEM_CONTACTO",
  "TRANSPORTE",
  "OUTRO",
];

const MOTIVOS_FALTA_LEGIVEL = {
  AGENDAMENTO_CANCELADO: "Agendamento Cancelado",
  CONDICAO_CLIMATICA: "Condições climáticas",
  DOENCA: "Doença",
  EMERGENCIA_FAMILIAR: "Emergência familiar",
  ESQUECIMENTO: "Esquecimento",
  MELHORA_DOS_SINTOMAS: "Melhora dos sintomas",
  PROBLEMAS_FINANCEIROS: "Problemas financeiros",
  SEM_CONTACTO: "Sem contacto",
  TRANSPORTE: "Problemas de transporte",
  OUTRO: "Outro motivo",
};

// Estilo para o multiselect
const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

function MarcacoesTratamentoSecretaria({ verPdf }) {
  const { startLoading, stopLoading } = useLoading();

  const [marcacoes, setMarcacoes] = useState();
  const [allMarcacoes, setAllMarcacoes] = useState();
  const [allMarcacoesSpecificDate, setAllMarcacoesSpecificDate] = useState([]);
  const [dataSelectAtendimentosDe, setDataSelectAtendimentosDe] = useState(
    format(new Date(), "dd-MM-yyyy"),
  );
  // Alteração aqui: transformamos o valor de select em um array para multiselect
  const [medicosSelectValue, setMedicosSelectValue] = useState([]);
  const [listaPresenca, setListaPresenca] = useState([]);
  const [dataDatePicker, setDataDatePicker] = useState(new Date());
  const [showDatePicker, setShowDatePicker] = useState(false);
  const { sendRequest } = useHttpClient();
  const [verAtendidos, setVerAtendidos] = useState(false);
  // Compromissos à parte das marcações porque não são atendimentos: não contam
  // para os totais nem para os estados SMS. Dois estados pela mesma razão que
  // as marcações — um para a janela ontem/hoje/amanhã, outro para o dia escolhido
  // no date picker.
  const [compromissosJanela, setCompromissosJanela] = useState([]);
  const [compromissosSpecificDate, setCompromissosSpecificDate] = useState([]);
  // Desligado por omissão: a lista é dos atendimentos do dia, e os compromissos
  // empurram-nos para baixo. Quem os quiser ver liga o interruptor.
  const [verCompromissos, setVerCompromissos] = useState(false);
  const auth = useContext(AuthContext);

  /* De que unidade são as marcações deste ecrã. Arranca na da sessão: quem
     está ao balcão trabalha num sítio concreto.
     Fica depois do `auth` de propósito — o inicializador lê-o. */
  const [unidadeDados, setUnidadeDados] = useState(
    () => auth.estabelecimento?._id ?? null,
  );
  const verTodasUnidades = unidadeDados === TODAS_UNIDADES;

  // O intervalo em vista. Ver a nota no `fetchMarcacoesSecretaria`.
  const intervaloEmVista = useRef({ startDate: null, endDate: null });
  const clinica = useContext(ClinicaContext);

  //Mui Button adicionar
  const [anchorEl, setAnchorEl] = useState(null);
  const openDropdown = Boolean(anchorEl);

  const [imprimirDialogOpen, setImprimirDialogOpen] = useState(false);
  const [medicoParaImprimir, setMedicoParaImprimir] = useState(null);

  // Estados para o diálogo de confirmação de falta
  const [motivoFaltaDialogOpen, setMotivoFaltaDialogOpen] = useState(false);
  const [marcacaoIdParaFalta, setMarcacaoIdParaFalta] = useState(null);

  /* Lembretes SMS — o mesmo hook do gémeo da agenda normal.
   *
   * O `true` diz-lhe que esta é a agenda de TRATAMENTOS: as marcações vivem na
   * colecção `AgendaTratamento` e é lá que o servidor as tem de ir buscar. */
  const {
    estadosSms,
    enviandoSmsId,
    enviandoSmsTodos,
    enviarSmsIndividual,
    enviarSmsTodos,
    confirmacaoSmsDialogOpen,
    setConfirmacaoSmsDialogOpen,
    abrirConfirmacaoSmsTodos,
    pendentesCount,
  } = useSmsLembretes(marcacoes, true);

  useWebSocketSubscription(
    async (parsedSocketData) => {
      if (parsedSocketData.tabela === "listapresencas") {
        const fetchListaPresenca = async () => {
          try {
            const responseData = await sendRequest(
              `${process.env.REACT_APP_BACKEND_LINK}/api/listapresenca/${clinica.clinica._id}`,
              "GET",
              null,
              {
                Authorization: "Bearer " + auth.token,
              },
            );
            setListaPresenca(responseData.listaPresenca);
          } catch (err) {}
        };

        fetchListaPresenca();
      }
    },
    [auth, clinica.clinica._id, sendRequest],
    "Dashboard",
  );

  const handleClickDropdown = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseDropdown = () => {
    setAnchorEl(null);
  };

  const handleImprimir = (idMedico) => {
    setMedicoParaImprimir(idMedico);
    setImprimirDialogOpen(true);
    handleCloseDropdown();
  };

  const confirmarImpressao = (incluirObservacoes) => {
    verPdf(
      medicoParaImprimir,
      marcacoes,
      dataSelectAtendimentosDe === "escolher-data"
        ? format(dataDatePicker, "dd-MM-yyyy")
        : dataSelectAtendimentosDe,
      incluirObservacoes,
      // A unidade escolhida no filtro vai para o cabeçalho da lista impressa.
      nomeUnidadeEscolhida(unidadeDados, auth, marcacoes),
    );
    setImprimirDialogOpen(false);
    setMedicoParaImprimir(null);
  };

  useEffect(() => {
    if (auth.usuariosAssociados && auth.usuariosAssociados.length === 1) {
      // Se só há um médico, selecionamos ele por padrão
      setMedicosSelectValue([auth.usuariosAssociados[0].id]);
    } else if (auth.usuariosAssociados && auth.usuariosAssociados.length > 1) {
      // Se há múltiplos médicos, selecionamos todos por padrão
      setMedicosSelectValue(auth.usuariosAssociados.map((medico) => medico.id));
    }

    const fetchMarcacoesAndListaPresenca = async () => {
      try {
        startLoading();
        const today = new Date();
        const ontem = subDays(today, 1);
        const amanha = addDays(today, 1);

        const tempMarcacoesDaFuncao = await fetchMarcacoesSecretaria(
          ontem,
          amanha,
        );

        const responseDataLista = await sendRequest(
          `${process.env.REACT_APP_BACKEND_LINK}/api/listapresenca/${clinica.clinica._id}`,
          "GET",
          null,
          {
            Authorization: "Bearer " + auth.token,
          },
        );

        setListaPresenca(responseDataLista.listaPresenca);

        const tempAllMarcacoes = [...tempMarcacoesDaFuncao];

        const tempMarcacoes = tempAllMarcacoes.filter(
          (mr) =>
            format(new Date(mr.data_inicio_execucao), "dd-MM-yyyy") ===
            format(new Date(), "dd-MM-yyyy"),
        );

        const sortedAllMarcacoes = tempAllMarcacoes.sort((a, b) => {
          return (
            new Date(a.data_inicio_execucao) - new Date(b.data_inicio_execucao)
          );
        });

        const sorteMarcacoes = tempMarcacoes.sort((a, b) => {
          return (
            new Date(a.data_inicio_execucao) - new Date(b.data_inicio_execucao)
          );
        });

        setAllMarcacoes(sortedAllMarcacoes);
        setMarcacoes(sorteMarcacoes);
        setCompromissosJanela(await fetchCompromissosSecretaria(ontem, amanha));
      } catch (err) {
        console.error("err", err);
      } finally {
        stopLoading();
      }
    };

    fetchMarcacoesAndListaPresenca();
  }, [sendRequest, clinica, auth]);

  const fetchMarcacoesSecretaria = async (
    startDate,
    endDate,
    unidade = unidadeDados,
  ) => {
    const marcacoesTrabalhadas = [];

    // O intervalo em vista, para o seletor de unidade poder repetir o pedido.
    intervaloEmVista.current = { startDate, endDate };

    try {
      startLoading();
      const formData = new FormData();
      formData.append(
        "medicos",
        JSON.stringify(auth.usuariosAssociados.map((m) => m.id)),
      );

      formData.append("startDate", startDate);
      formData.append("endDate", endDate);

      /* Trocar de unidade é um pedido novo, não um recorte do que já veio.
         Sem parâmetros o servidor devolve a unidade da sessão.

         O mesmo `formData` serve os três pedidos abaixo — agenda, transição e
         isolados — por isso a unidade vai nos três. */
      for (const [chave, valor] of Object.entries(
        paramsUnidadeDados(unidade, auth),
      )) {
        formData.append(chave, valor);
      }

      const responseData = await sendRequest(
        `${process.env.REACT_APP_BACKEND_LINK}/api/agendatratamento/marcacoessecretaria/${clinica.clinica._id}`,
        "PATCH",
        formData,
        {
          Authorization: "Bearer " + auth.token,
        },
      );

      const responseData2 = await sendRequest(
        `${process.env.REACT_APP_BACKEND_LINK}/api/agendamentostratamentoemtransicao/marcacoessecretaria/${clinica.clinica._id}`,
        "PATCH",
        formData,
        {
          Authorization: "Bearer " + auth.token,
        },
      );

      const responseDataTratamentoIsolados = await sendRequest(
        `${process.env.REACT_APP_BACKEND_LINK}/api/tratamentoIsolados/marcacoessecretaria/${clinica.clinica._id}`,
        "PATCH",
        formData,
        {
          Authorization: "Bearer " + auth.token,
        },
      );

      responseData.marcacoes.forEach((mr) => {
        marcacoesTrabalhadas.push({
          id: mr._id,
          nome: mr.cliente.nome,
          contacto: mr.cliente.contacto,
          data_inicio_execucao: mr.data_inicio_execucao,
          data_fim_execucao: mr.data_fim_execucao,
          /* `planoTratamento` passou a vir POPULADO (traz a cobertura do
             orçamento), por isso já não é um id. */
          idPlano: mr.avaliacao
            ? null
            : mr.planoTratamento?._id || mr.planoTratamento,
          orcamento: mr.orcamento,
          cobertura:
            mr.orcamento?.beneficio ||
            mr.planoTratamento?.orcamento?.beneficio ||
            null,
          idCliente: mr.cliente._id,
          medico: mr.medico,
          tratamento: mr.tratamento,
          avaliacao: mr.avaliacao ? true : false,
          atendido: mr.atendido,
          faltou: mr.faltou,
          observacoesAgendamento: mr.observacoesAgendamento,
          /* A confirmação de presença, com o nome de quem confirmou — é o que
             o tooltip do ✓ mostra. Só a `AgendaTratamento` a tem: os
             agendamentos em transição e os tratamentos isolados ficam sem
             ícone, de propósito. */
          confirmacao: mr.confirmacao,
          // Sem isto a linha perde a unidade a caminho da tabela, e nem a
          // pastilha nem o bloqueio das ações têm por onde se decidir.
          estabelecimento: mr.estabelecimento,
        });
      });

      responseData2.marcacoes.forEach((mr) => {
        marcacoesTrabalhadas.push({
          id: mr._id,
          nome: mr.cliente.nome,
          contacto: mr.cliente.contacto,
          data_inicio_execucao: mr.data_inicio_execucao,
          data_fim_execucao: mr.data_fim_execucao,
          idCliente: mr.cliente._id,
          medico: mr.medico,
          tratamento: mr.tratamento,
          avaliacao: mr.avaliacao ? true : false,
          atendido: mr.atendido,
          faltou: mr.faltou,
          emTransicao: true,
          observacoesAgendamento: mr.observacoesAgendamento,
          estabelecimento: mr.estabelecimento,
        });
      });

      responseDataTratamentoIsolados.tratamentoIsolados.forEach((cl) => {
        marcacoesTrabalhadas.push({
          id: cl._id,
          nome: cl.cliente.nome,
          contacto: cl.cliente.contacto,
          data_inicio_execucao: cl.data_inicio_execucao,
          data_fim_execucao: cl.data_fim_execucao,
          idCliente: cl.cliente._id,
          medico: cl.medico,
          atendido: cl.atendido,
          faltou: cl.faltou,
          tratamentoIsolado: true,
          // Não pertence a orçamento nenhum — não há cobertura a mostrar.
          cobertura: "TI",
          observacoesAgendamento: cl.observacoesAgendamento,
          tratamento: cl.tratamento.designacao,
          /* Faltava, e por isso o ✓ nao aparecia nos tratamentos isolados
             desta lista — a coluna testa `row.confirmacao?.data`. */
          confirmacao: cl.confirmacao,
          estabelecimento: cl.estabelecimento,
        });
      });
    } catch (err) {
      console.error(err);
    } finally {
      stopLoading();
    }
    return marcacoesTrabalhadas;
  };

  /* Um só pedido para todos os médicos associados, com o intervalo já limitado
     aos dias em vista. Os limites são calculados aqui, no fuso de quem está a
     ver, para o dia ser o dela e não o do servidor.

     Gémeo do da lista da agenda normal — e é o MESMO endpoint: um compromisso
     é tempo do médico («almoço», «reunião», «formação»), não um atendimento,
     por isso não pertence a nenhuma das duas agendas. */
  const fetchCompromissosSecretaria = async (
    startDate,
    endDate,
    unidade = unidadeDados,
  ) => {
    if (!auth.usuariosAssociados || auth.usuariosAssociados.length === 0) {
      return [];
    }

    const medicos = auth.usuariosAssociados.map((m) => m.id);

    try {
      const resposta = await sendRequest(
        `${process.env.REACT_APP_BACKEND_LINK}/api/compromissos/listaatendimento/${
          clinica.clinica._id
        }?medicos=${medicos.join(",")}&startDate=${encodeURIComponent(
          startOfDay(startDate).toISOString(),
        )}&endDate=${encodeURIComponent(
          endOfDay(endDate).toISOString(),
        )}${queryUnidadeDados(unidade, auth, true)}`,
        "GET",
        null,
        {
          Authorization: "Bearer " + auth.token,
        },
      );

      return (resposta.compromissos || []).map((c) => {
        const medico = auth.usuariosAssociados.find((m) => m.id === c.medico);
        return {
          id: c._id,
          isCompromisso: true,
          compromisso: c.compromisso,
          data_inicio_execucao: c.data_inicio_execucao,
          data_fim_execucao: c.data_fim_execucao,
          medicoId: c.medico,
          medicoNome: medico ? medico.nome : "",
          estabelecimento: c.estabelecimento,
        };
      });
    } catch (err) {
      console.error("Erro ao carregar compromissos:", err);
      return [];
    }
  };

  /* Modificação na função de filtro para funcionar com múltiplos médicos
   *
   * O quarto argumento existe para quem acabou de ir buscar dados novos ao
   * servidor e ainda não os vê no estado. `allMarcacoes` só muda na passagem
   * SEGUINTE, por isso quem trocou de unidade e filtrasse já estaria a filtrar
   * a unidade anterior. Sem ele, o seletor de unidade vinha com a lista vazia.
   * Quem não o passa continua a ler o estado, como sempre. */
  const filterMarcacoes = useCallback(
    (
      medicos,
      data,
      marcacoesSpecificDate = [...allMarcacoesSpecificDate],
      todasAsMarcacoes = allMarcacoes,
    ) => {
      let tempMarcacoes;
      let temp;

      if (data === "escolher-data") {
        if (
          medicos.length === 0 ||
          medicos.length === auth.usuariosAssociados.length
        ) {
          // Se não há médicos selecionados ou todos estão selecionados, mostrar todos
          temp = [...marcacoesSpecificDate];
        } else {
          // Filtrar por médicos selecionados
          temp = marcacoesSpecificDate.filter((mr) =>
            medicos.includes(mr.medico._id),
          );
        }
      } else if (data === format(new Date(), "dd-MM-yyyy")) {
        if (
          medicos.length === 0 ||
          medicos.length === auth.usuariosAssociados.length
        ) {
          // Se não há médicos selecionados ou todos estão selecionados, mostrar todos
          temp = todasAsMarcacoes.filter(
            (mr) =>
              format(new Date(mr.data_inicio_execucao), "dd-MM-yyyy") === data,
          );
        } else {
          // Filtrar por médicos selecionados
          temp = todasAsMarcacoes.filter(
            (mr) =>
              medicos.includes(mr.medico._id) &&
              format(new Date(mr.data_inicio_execucao), "dd-MM-yyyy") === data,
          );
        }
        temp.sort((a, b) => {
          return (
            new Date(a.data_inicio_execucao) - new Date(b.data_inicio_execucao)
          );
        });
      } else {
        if (
          medicos.length === 0 ||
          medicos.length === auth.usuariosAssociados.length
        ) {
          // Se não há médicos selecionados ou todos estão selecionados, mostrar todos
          temp = todasAsMarcacoes.filter(
            (mr) =>
              format(new Date(mr.data_inicio_execucao), "dd-MM-yyyy") === data,
          );
        } else {
          // Filtrar por médicos selecionados
          temp = todasAsMarcacoes.filter(
            (mr) =>
              medicos.includes(mr.medico._id) &&
              format(new Date(mr.data_inicio_execucao), "dd-MM-yyyy") === data,
          );
        }
      }
      tempMarcacoes = temp.sort((a, b) => {
        return (
          new Date(a.data_inicio_execucao) - new Date(b.data_inicio_execucao)
        );
      });

      setMarcacoes(tempMarcacoes);
    },
    [allMarcacoes, allMarcacoesSpecificDate, auth.usuariosAssociados],
  );

  const changeSelectAtendimentosDe = useCallback(
    (e) => {
      setDataSelectAtendimentosDe(e.target.value);
      if (e.target.value === "escolher-data") {
        setShowDatePicker(true);
      } else {
        setShowDatePicker(false);
        filterMarcacoes(medicosSelectValue, e.target.value);
      }
    },

    [filterMarcacoes, medicosSelectValue],
  );

  // Função modificada para lidar com seleção múltipla
  const changeMedicoDaLista = (event) => {
    const {
      target: { value },
    } = event;

    // Atualiza o estado com os valores selecionados
    setMedicosSelectValue(
      // Em caso de string, converte para array
      typeof value === "string" ? value.split(",") : value,
    );

    // Filtra as marcações com os novos valores selecionados
    filterMarcacoes(
      typeof value === "string" ? value.split(",") : value,
      dataSelectAtendimentosDe,
    );
  };

  const handleAguardando = useCallback(
    async (id) => {
      // ✅ Corrigir a verificação
      const clientePresente = listaPresenca.find(
        (item) => item.clienteId === id,
      );

      if (!clientePresente) {
        try {
          const formData = new FormData();
          formData.append("clienteId", id);

          await sendRequest(
            `${process.env.REACT_APP_BACKEND_LINK}/api/listaPresenca/adicionarclientealista/${clinica.clinica._id}`,
            "PATCH",
            formData,
            {
              Authorization: "Bearer " + auth.token,
            },
          );

          // ✅ Adicionar o objeto completo
          setListaPresenca((prev) => [
            ...prev,
            { clienteId: id, horarioChegada: new Date() },
          ]);
        } catch (err) {
          console.error("err", err);
        }
      }
    },
    [auth.token, clinica.clinica._id, listaPresenca, sendRequest],
  );

  const handleSaiu = useCallback(
    async (id) => {
      // Verificar se o cliente está presente procurando no array de objetos
      const clientePresente = listaPresenca.find(
        (item) => item.clienteId === id,
      );

      if (clientePresente) {
        try {
          const formData = new FormData();
          formData.append("clienteId", id);

          await sendRequest(
            `${process.env.REACT_APP_BACKEND_LINK}/api/listaPresenca/removerclientedalista/${clinica.clinica._id}`,
            "DELETE",
            formData,
            {
              Authorization: "Bearer " + auth.token,
            },
          );

          // Filtrar removendo o objeto que tem este clienteId
          setListaPresenca((prev) =>
            prev.filter((item) => item.clienteId !== id),
          );
        } catch (err) {
          console.error("err", err);
        }
      }
    },
    [auth.token, clinica.clinica._id, listaPresenca, sendRequest],
  );

  const changeDataDatePicker = async (value) => {
    setDataDatePicker(value);
    if (!value || isNaN(new Date(value).getTime())) return;
    startLoading();
    try {
      const formData = new FormData();
      formData.append(
        "medicos",
        JSON.stringify(auth.usuariosAssociados.map((m) => m.id)),
      );
      const tempMarcacoes = await fetchMarcacoesSecretaria(value, value);

      const temp = tempMarcacoes.sort((a, b) => {
        return (
          new Date(a.data_inicio_execucao) - new Date(b.data_inicio_execucao)
        );
      });

      setAllMarcacoesSpecificDate(temp);
      setCompromissosSpecificDate(
        await fetchCompromissosSecretaria(value, value),
      );

      filterMarcacoes(medicosSelectValue, "escolher-data", temp);
    } catch (err) {
      console.error("err", err);
    } finally {
      stopLoading();
    }
  };

  // Função para obter nomes dos médicos selecionados a partir dos IDs, mostrando apenas primeiro e último nome
  const getMedicoNames = () => {
    if (!auth.usuariosAssociados) return [];

    return medicosSelectValue.map((medicoId) => {
      const medico = auth.usuariosAssociados.find((m) => m.id === medicoId);
      if (!medico) return "";

      // Extrair primeiro e último nome
      const nomeCompleto = medico.nome;
      const partes = nomeCompleto.split(" ");

      if (partes.length === 1) {
        return partes[0]; // Caso tenha apenas um nome
      } else {
        return `${partes[0]} ${partes[partes.length - 1]}`; // Primeiro e último nome
      }
    });
  };

  const marcarFalta = async (marcacaoId, motivoTipo, motivoDetalhes) => {
    startLoading();
    try {
      const formData = new FormData();
      formData.append("utilizador", auth.userId);

      formData.append("motivoFaltaTipo", motivoTipo);
      formData.append("motivoFaltaDetalhes", motivoDetalhes);

      let path = "agendatratamento";
      const marcacaoFiltrada = marcacoes.filter((m) => m.id === marcacaoId)[0];

      if (marcacaoFiltrada && marcacaoFiltrada.tratamentoIsolado) {
        path = "tratamentoIsolados";
      } else if (marcacaoFiltrada && marcacaoFiltrada.emTransicao) {
        path = "agendamentostratamentoemtransicao";
      }

      await sendRequest(
        `${process.env.REACT_APP_BACKEND_LINK}/api/${path}/marcarfalta/${marcacaoId}`,
        "PATCH",
        formData,
        {
          Authorization: "Bearer " + auth.token,
        },
      );

      const toUpdate = { faltou: true, atendido: false };

      setMarcacoes((prevMarcacoes) =>
        prevMarcacoes.map((m) => {
          if (m.id === marcacaoId) {
            return { ...m, ...toUpdate };
          } else {
            return m;
          }
        }),
      );

      toast.success("Falta marcada com sucesso!");
    } catch (err) {
      console.error("err", err);
    } finally {
      stopLoading();
    }
  };

  /* Marcar que o cliente confirmou que vem. Gémeo do da agenda normal; a
   * explicação está lá e no helper partilhado. */
  const confirmarPresenca = async (marcacaoId) => {
    startLoading();
    try {
      /* A mesma linha da lista pode vir de quatro coleções. O caminho
         escolhe-se como já se escolhe no `marcarfalta` — era isto que faltava
         para os tratamentos isolados terem botão. */
      const linha = marcacoes.filter((m) => m.id === marcacaoId)[0];
      let path = "agendatratamento";
      if (linha?.tratamentoIsolado) path = "tratamentoIsolados";
      else if (linha?.emTransicao) path = "agendamentostratamentoemtransicao";

      const resposta = await sendRequest(
        `${process.env.REACT_APP_BACKEND_LINK}/api/${path}/confirmar/${marcacaoId}`,
        "PATCH",
        null,
        { Authorization: "Bearer " + auth.token },
      );

      setMarcacoes((prevMarcacoes) =>
        prevMarcacoes.map((m) =>
          m.id === marcacaoId ? { ...m, confirmacao: resposta.confirmacao } : m,
        ),
      );

      toast.success(
        resposta.jaEstava
          ? "Este agendamento já estava confirmado."
          : "Presença confirmada.",
      );
    } catch (err) {
      /* A mensagem do servidor, para o 403 de «só a secretária» e o 422 de
         «só dias seguintes» chegarem ao ecrã em vez de morrerem na consola. */
      toast.error(err.message || "Não foi possível confirmar a presença.");
    } finally {
      stopLoading();
    }
  };


  const removerFalta = async (marcacaoId) => {
    startLoading();
    try {
      let path = "agendatratamento";
      const marcacaoFiltrada = marcacoes.filter((m) => m.id === marcacaoId)[0];

      if (marcacaoFiltrada && marcacaoFiltrada.tratamentoIsolado) {
        path = "tratamentoIsolados";
      }
      const formData = new FormData();
      formData.append("utilizador", auth.userId);
      await sendRequest(
        `${process.env.REACT_APP_BACKEND_LINK}/api/${path}/removerfalta/${marcacaoId}`,
        "PATCH",
        formData,
        { Authorization: "Bearer " + auth.token },
      );

      setMarcacoes((prevMarcacoes) =>
        prevMarcacoes.map((m) =>
          m.id === marcacaoId ? { ...m, faltou: false } : m,
        ),
      );

      toast.success("Falta removida com sucesso!");
    } catch (err) {
      console.error("err", err);
    } finally {
      stopLoading();
    }
  };

  // Abre o diálogo e guarda o ID da marcação
  const abrirDialogoMotivoFalta = (marcacaoId) => {
    setMarcacaoIdParaFalta(marcacaoId);
    setMotivoFaltaDialogOpen(true);
  };

  // Fecha o diálogo
  const fecharDialogoMotivoFalta = () => {
    setMotivoFaltaDialogOpen(false);
    setMarcacaoIdParaFalta(null);
  };

  // Função para o formulário de envio (que evita o uso de states)
  const submeterFormularioFalta = (event) => {
    event.preventDefault();
    const formData = new FormData(event.target);
    const motivoTipo = formData.get("motivoFaltaTipo");
    const motivoDetalhes = formData.get("motivoFaltaDetalhes");

    if (!motivoTipo) {
      toast.error("Por favor, selecione o motivo da falta.");
      return;
    }

    marcarFalta(marcacaoIdParaFalta, motivoTipo, motivoDetalhes);
    fecharDialogoMotivoFalta();
  };

  // Função auxiliar para verificar se cliente está presente e obter horário
  const getClientePresenca = (clienteId) => {
    const presente = listaPresenca.find((item) => item.clienteId === clienteId);
    return presente || null;
  };

  // Função para formatar horário
  const formatarHorario = (horarioChegada) => {
    return format(new Date(horarioChegada), "HH:mm");
  };

  // Compromissos entram na ordem cronológica, entre os atendimentos. Não têm
  // estado, por isso o filtro "Ver Atendidos" não os afeta — mas respeitam
  // o filtro de médicos, tal como as marcações.
  //
  // O do date picker já vem só com o dia pedido; o da janela cobre ontem, hoje
  // e amanhã, e é aqui que se escolhe qual desses três está em vista.
  const compromissosDoDia =
    dataSelectAtendimentosDe === "escolher-data"
      ? compromissosSpecificDate
      : compromissosJanela.filter(
          (c) =>
            format(new Date(c.data_inicio_execucao), "dd-MM-yyyy") ===
            dataSelectAtendimentosDe,
        );

  const compromissosVisiveis = verCompromissos
    ? compromissosDoDia.filter(
        (c) =>
          medicosSelectValue.length === 0 ||
          medicosSelectValue.length === auth.usuariosAssociados?.length ||
          medicosSelectValue.includes(c.medicoId),
      )
    : [];

  const marcacoesVisiveis = (marcacoes || []).filter(
    (row) => verAtendidos || !(row.atendido || row.faltou),
  );

  const linhasVisiveis = [...marcacoesVisiveis, ...compromissosVisiveis].sort(
    (a, b) =>
      new Date(a.data_inicio_execucao) - new Date(b.data_inicio_execucao),
  );

  return (
    <>
      {auth && auth.usuariosAssociados && (
        <>
          <div className="marcacoes-secretaria__titulo">
            Lista de Atendimento
          </div>

          {/* De que unidade são estas marcações. Trocar refaz o pedido ao
              servidor, para o mesmo intervalo que está em vista.

              Numa linha só, acima dos controlos: é o contexto de todo o ecrã e
              não um controlo da lista. Na linha dos selects e dos interruptores
              empurrava-os para o lado e estragava-a. */}
          <div className="marcacoes-secretaria__unidade">
            <SeletorUnidadeDados
              valor={unidadeDados}
              onChange={async (nova) => {
                setUnidadeDados(nova);
                if (!intervaloEmVista.current.startDate) return;

                /* ─── OS DOIS CACHES TÊM DE TROCAR DE UNIDADE JUNTOS ────────
                 *
                 * Este ecrã guarda as marcações em dois sítios: a JANELA de
                 * ontem/hoje/amanhã, de onde o seletor de dia lê, e o DIA
                 * ESCOLHIDO no calendário. A troca de unidade refrescava só o
                 * que estava em vista, e o outro ficava com a unidade
                 * anterior — à espera de ser mostrado.
                 *
                 * Dava isto: estando na Praia, escolher a Assomada e depois
                 * «Amanhã» mostrava o amanhã DA PRAIA, porque o seletor de
                 * dia lê da janela e a janela não tinha mudado. E vice-versa
                 * com o calendário.
                 *
                 * Por isso a janela é sempre pedida de novo, esteja ou não em
                 * vista. A unidade nova vai por argumento: o `setState` ainda
                 * não se vê nesta passagem, e o pedido sairia com a antiga. */
                const agora = new Date();
                const ontem = subDays(agora, 1);
                const amanha = addDays(agora, 1);
                const noCalendario =
                  dataSelectAtendimentosDe === "escolher-data";

                const janela = await fetchMarcacoesSecretaria(
                  ontem,
                  amanha,
                  nova,
                );
                setAllMarcacoes(janela);
                setCompromissosJanela(
                  await fetchCompromissosSecretaria(ontem, amanha, nova),
                );

                /* O resultado vai para o MESMO sítio de onde o filtro lê, e
                   só depois se filtra — em vez de ser atirado direto para a
                   lista, como estava. Assim fica com o dia em vista e com os
                   médicos escolhidos, em vez dos três dias todos. */
                if (noCalendario) {
                  const doDia = await fetchMarcacoesSecretaria(
                    dataDatePicker,
                    dataDatePicker,
                    nova,
                  );
                  setAllMarcacoesSpecificDate(doDia);
                  setCompromissosSpecificDate(
                    await fetchCompromissosSecretaria(
                      dataDatePicker,
                      dataDatePicker,
                      nova,
                    ),
                  );
                  filterMarcacoes(medicosSelectValue, "escolher-data", doDia);
                } else {
                  filterMarcacoes(
                    medicosSelectValue,
                    dataSelectAtendimentosDe,
                    undefined,
                    janela,
                  );
                }
              }}
            />
          </div>

          <div className="marcacoes-secretaria-header-row">
            <div className="box-escolha-de-dia">
              <FormControl sx={{ width: 150, mr: 1 }}>
                <InputLabel id="data-select-label">Data</InputLabel>
                <Select
                  labelId="data-select-label"
                  id="data-select"
                  value={dataSelectAtendimentosDe}
                  onChange={changeSelectAtendimentosDe}
                  label="Data"
                  size="small"
                >
                  <MenuItem
                    value={format(subDays(new Date(), 1), "dd-MM-yyyy")}
                  >
                    Ontem
                  </MenuItem>
                  <MenuItem value={format(new Date(), "dd-MM-yyyy")}>
                    Hoje
                  </MenuItem>
                  <MenuItem
                    value={format(addDays(new Date(), 1), "dd-MM-yyyy")}
                  >
                    Amanhã
                  </MenuItem>
                  <MenuItem value="escolher-data">Escolher Data</MenuItem>
                </Select>
              </FormControl>

              {auth.usuariosAssociados.length > 1 && (
                <>
                  {/* Multiselect com largura aumentada */}
                  <FormControl sx={{ width: 450, m: 1 }}>
                    <InputLabel id="multiple-medico-label">Médicos</InputLabel>
                    <Select
                      labelId="multiple-medico-label"
                      id="multiple-medico"
                      multiple
                      value={medicosSelectValue}
                      onChange={changeMedicoDaLista}
                      input={<OutlinedInput label="Médicos" />}
                      renderValue={(selected) => (
                        <Box
                          sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}
                        >
                          {getMedicoNames().map((name) => (
                            <Chip key={name} label={name} size="small" />
                          ))}
                        </Box>
                      )}
                      MenuProps={MenuProps}
                      size="small"
                    >
                      {auth.usuariosAssociados.map((medico) => (
                        <MenuItem key={medico.id} value={medico.id}>
                          <Checkbox
                            checked={medicosSelectValue.indexOf(medico.id) > -1}
                          />
                          <ListItemText
                            primary={(() => {
                              const partes = medico.nome.split(" ");
                              if (partes.length === 1) return partes[0];
                              return `${partes[0]} ${
                                partes[partes.length - 1]
                              }`;
                            })()}
                          />
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </>
              )}

              {showDatePicker && (
                <LocalizationProvider
                  dateAdapter={AdapterDateFns}
                  adapterLocale={ptBR}
                  className="adicionar-despesa__modal__container--span1"
                >
                  <DesktopDatePicker
                    sx={{ width: 200, m: 1 }}
                    className="valorDataCaixa__fields--field muiDatePicker"
                    label="Data*"
                    inputFormat="dd-MM-yyyy"
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        sx={{
                          width: "150px",
                        }}
                      />
                    )}
                    onChange={(value) => changeDataDatePicker(value)}
                    value={dataDatePicker}
                  />
                </LocalizationProvider>
              )}

              <div
                className="checkbox-wrapper-51"
                id="ver-atendidos__checkbox-container"
              >
                <span className="box-title--atendimentosSecretaria">
                  Ver Atendidos
                </span>
                <input
                  type="checkbox"
                  id="mostrarRecebidos"
                  onChange={(e) => setVerAtendidos(e.target.checked)}
                  checked={verAtendidos}
                />
                <label htmlFor="mostrarRecebidos" className="toggle">
                  <span>
                    <svg width="10px" height="10px" viewBox="0 0 10 10">
                      <path d="M5,1 L5,1 C2.790861,1 1,2.790861 1,5 L1,5 C1,7.209139 2.790861,9 5,9 L5,9 C7.209139,9 9,7.209139 9,5 L9,5 C9,2.790861 7.209139,1 5,1 L5,9 L5,1 Z"></path>
                    </svg>
                  </span>
                </label>
              </div>

              <div
                className="checkbox-wrapper-51"
                id="ver-compromissos__checkbox-container"
              >
                <span className="box-title--atendimentosSecretaria">
                  Ver Compromissos
                </span>
                <input
                  type="checkbox"
                  id="mostrarCompromissos"
                  onChange={(e) => setVerCompromissos(e.target.checked)}
                  checked={verCompromissos}
                />
                <label htmlFor="mostrarCompromissos" className="toggle">
                  <span>
                    <svg width="10px" height="10px" viewBox="0 0 10 10">
                      <path d="M5,1 L5,1 C2.790861,1 1,2.790861 1,5 L1,5 C1,7.209139 2.790861,9 5,9 L5,9 C7.209139,9 9,7.209139 9,5 L9,5 C9,2.790861 7.209139,1 5,1 L5,9 L5,1 Z"></path>
                    </svg>
                  </span>
                </label>
              </div>
            </div>

            <div style={{ display: "flex", gap: "8px" }}>
              {/* Só aparece se houver alguém por avisar. */}
              {SMS_ATIVO &&
                marcacoes?.some(
                (row) =>
                  !row.atendido && !row.faltou && !estadosSms[row.id]?.enviado,
              ) && (
                <Button
                  variant="outlined"
                  color="primary"
                  onClick={abrirConfirmacaoSmsTodos}
                  disabled={enviandoSmsTodos}
                  startIcon={<SmsIcon />}
                  style={{ padding: "5px 10px", fontSize: "13px" }}
                >
                  {enviandoSmsTodos ? "A enviar..." : "SMS para todos"}
                </Button>
              )}
              <Button
                variant="contained"
                color="success"
                id="basic-button"
                aria-controls={openDropdown ? "basic-menu" : undefined}
                aria-haspopup="true"
                aria-expanded={openDropdown ? "true" : undefined}
                onClick={handleClickDropdown}
                style={{ padding: "5px 10px", fontSize: "13px" }}
              >
                Imprimir
              </Button>
              <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={openDropdown}
                onClose={handleCloseDropdown}
                MenuListProps={{
                  "aria-labelledby": "basic-button",
                }}
              >
                {auth.usuariosAssociados.map((m, index) => (
                  <MenuItem
                    key={index}
                    onClick={handleImprimir.bind(null, m)}
                    style={{ padding: "5px 10px", fontSize: "14px" }}
                  >
                    {m.nome}
                  </MenuItem>
                ))}
              </Menu>
            </div>
          </div>
        </>
      )}

      {linhasVisiveis.length > 0 && (
        <TableContainer component={Paper} className="tableMarcacoes">
          <Table sx={{ minWidth: 650 }} aria-label="simple table">
            <TableHead style={{ backgroundColor: "white" }}>
              <TableRow className="marcacoesAdministrativo__tableHeading">
                <TableCell align="left">Cliente</TableCell>
                <TableCell align="left">Médico</TableCell>
                <TableCell align="left">Procedimento</TableCell>
                <TableCell align="left">Contacto</TableCell>
                <TableCell align="left">Inicio</TableCell>
                <TableCell align="left">Fim</TableCell>
                <TableCell align="left">Obs</TableCell>
                {/* Coluna própria, independente do SMS, que está desligado. */}
                <TableCell align="left">Confirmação</TableCell>
                {SMS_ATIVO && <TableCell align="left">SMS</TableCell>}
                <TableCell align="left">Ação</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {linhasVisiveis.map((row) => {
                if (row.isCompromisso) {
                  return (
                    <TableRow key={row.id} className="row-compromisso">
                      <TableCell align="left">
                        <span className="compromisso-tag">Compromisso</span>
                        {/* A linha do compromisso é um `return` à parte e não
                            passa pela célula do cliente, onde a pastilha é
                            desenhada — sem isto, no consolidado ficava a única
                            linha da lista sem unidade. */}
                        {verTodasUnidades && (
                          <BadgeUnidade estabelecimento={row.estabelecimento} />
                        )}
                      </TableCell>
                      <TableCell align="left">{row.medicoNome}</TableCell>
                      <TableCell align="left" colSpan={2}>
                        <span className="compromisso-titulo">
                          {row.compromisso}
                        </span>
                      </TableCell>
                      <TableCell align="left">
                        {format(new Date(row.data_inicio_execucao), "HH:mm")}
                      </TableCell>
                      <TableCell align="left">
                        {format(new Date(row.data_fim_execucao), "HH:mm")}
                      </TableCell>
                      {/* Obs, Confirmação, [SMS] e Ação: um compromisso não
                          tem nada em nenhuma delas. */}
                      <TableCell colSpan={SMS_ATIVO ? 4 : 3} />
                    </TableRow>
                  );
                }
                return (
                  <TableRow
                    key={row.id}
                    sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                    className="tr__marcacoesSecretaria"
                  >
                    <TableCell align="left">
                      <Link
                        to={`/clientes/${row.idCliente}`}
                        className="linkNoNomeDoCliente"
                      >
                        <span>{row.nome}</span>
                      </Link>
                      <BadgeCobertura cobertura={row.cobertura} />
                      {/* Só no consolidado: com uma unidade escolhida, todas as
                          linhas são dela. */}
                      {verTodasUnidades && (
                        <BadgeUnidade estabelecimento={row.estabelecimento} />
                      )}
                    </TableCell>
                    <TableCell align="left" style={{ color: row.medico.cor }}>
                      <span
                        className="marcacoesAdministrativo__nome__medico__span"
                        style={{
                          color: row.medico.cor,
                          backgroundColor: lightenColor(
                            row.medico.cor,
                            40,
                            0.4,
                          ),
                        }}
                      >
                        {abreviarNome(row.medico.name)}
                      </span>
                    </TableCell>
                    <TableCell align="left">
                      {row.avaliacao
                        ? "Avaliação"
                        : row.tratamentoIsolado
                          ? row.tratamento
                          : row.tratamento.designacao}
                      {row.orcamento && " (Orçamento)"}
                    </TableCell>
                    <TableCell align="left">{row.contacto}</TableCell>
                    <TableCell align="left">
                      {format(new Date(row.data_inicio_execucao), "HH:mm")}
                    </TableCell>
                    <TableCell align="left">
                      {format(new Date(row.data_fim_execucao), "HH:mm")}
                    </TableCell>
                    {/* Obs */}
                    <TableCell align="left">
                      <ObservacoesAgendamentoTooltip
                        observacoes={row.observacoesAgendamento}
                      />
                    </TableCell>

                    {/* Confirmação de presença */}
                    <TableCell align="left">
                      {row.confirmacao?.data ? (
                        <span
                          title={textoConfirmacao(row.confirmacao)}
                          style={{
                            color: "#2e7d32",
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          <CheckCircleOutlineIcon
                            style={{ fontSize: "18px" }}
                          />
                        </span>
                      ) : /* Sem botão em quem já foi atendido ou faltou: a
                            confirmação é uma promessa sobre o futuro.
                            E só em DIAS SEGUINTES: no próprio dia já não se
                            pergunta «vem?» — marca-se «Chegou» ou «Faltou». */
                      /* Marcação de OUTRA unidade: sem botão.
                         Confirmar é um ato do balcão onde a pessoa vai
                         aparecer — quem o faz daqui está a dizer que falou com
                         alguém que vai a outro sítio. Com o filtro de «mostrar
                         agendamentos de outra unidade» ligado, estas linhas
                         aparecem na lista, e só o estado é que se vê.
                         A mesma guarda que já protege a falta e a presença. */
                      podeAlterarRegisto(row.estabelecimento, auth) &&
                        /* O dia em vista, não o valor do seletor: com
                           «Escolher Data» o seletor vale uma palavra e o dia
                           está no calendário ao lado. */
                        ehDeDiaFuturo(
                          diaEmVista(
                            dataSelectAtendimentosDe,
                            dataDatePicker,
                          ),
                        ) &&
                        !row.atendido &&
                        !row.faltou ? (
                        <button
                          className="confirmarPresencaButton"
                          onClick={() => confirmarPresenca(row.id)}
                          title="O cliente confirmou que vem"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "4px",
                          }}
                        >
                          <CheckCircleOutlineIcon
                            style={{ fontSize: "14px" }}
                          />
                          Confirmar
                        </button>
                      ) : null}
                    </TableCell>

                    {/* SMS */}
                    {SMS_ATIVO && (
                    <TableCell align="left">
                      {estadosSms[row.id]?.enviado ? (
                        <span
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "6px",
                          }}
                        >
                          <span
                            title="SMS enviado"
                            style={{
                              color: "#2e7d32",
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            <SmsIcon style={{ fontSize: "16px" }} />
                          </span>
                          {estadosSms[row.id]?.confirmado ? (
                            <span
                              title="Presença confirmada"
                              style={{
                                color: "#2e7d32",
                                display: "flex",
                                alignItems: "center",
                              }}
                            >
                              <CheckCircleOutlineIcon
                                style={{ fontSize: "16px" }}
                              />
                            </span>
                          ) : (
                            <span
                              title="Aguardando confirmação"
                              style={{
                                color: "#9e9e9e",
                                display: "flex",
                                alignItems: "center",
                              }}
                            >
                              <HourglassEmptyIcon
                                style={{ fontSize: "16px" }}
                              />
                            </span>
                          )}
                        </span>
                      ) : !row.atendido && !row.faltou ? (
                        <button
                          className="faltouButton"
                          onClick={() => enviarSmsIndividual(row)}
                          disabled={enviandoSmsId === row.id}
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "4px",
                          }}
                        >
                          <SmsIcon style={{ fontSize: "14px" }} />
                          {enviandoSmsId === row.id ? "..." : "SMS"}
                        </button>
                      ) : null}
                    </TableCell>
                    )}

                    <TableCell align="left">
                      {/* Marcação de outra unidade: só leitura. Marcar
                          presença, falta ou aprovar são operações do balcão
                          onde a pessoa está — daqui seriam feitas às cegas
                          sobre o outro. O estado continua visível; o que
                          desaparece são os botões. */}
                      {!podeAlterarRegisto(row.estabelecimento, auth) ? (
                        <>
                          {row.atendido && (
                            <span className="spanMensagemAtendido">
                              Atendido
                            </span>
                          )}
                          {row.faltou && (
                            <span className="spanMensagemFaltou">Faltou</span>
                          )}
                          <span
                            className="marcacoes__outra-unidade"
                            title={motivoBloqueioUnidade(row.estabelecimento)}
                          >
                            Outra unidade
                          </span>
                        </>
                      ) : (
                        <>
                          {row.atendido ? (
                            <span className="spanMensagemAtendido">
                              Atendido
                            </span>
                          ) : row.faltou ? (
                            <span
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "8px",
                              }}
                            >
                              <span className="spanMensagemFaltou">Faltou</span>
                              <button
                                className="faltouButton"
                                onClick={removerFalta.bind(null, row.id)}
                              >
                                Remover Falta
                              </button>
                            </span>
                          ) : (
                            ""
                          )}
                          {dataSelectAtendimentosDe ===
                          format(new Date(), "dd-MM-yyyy") ? (
                            <>
                              {row.orcamento && (
                                <Link
                                  to={`/clientes/${row.idCliente}-orcamento`}
                                  className="marcacoesSecretariaAprovarOrcamentoBtn"
                                >
                                  Aprovar
                                </Link>
                              )}

                              {!row.atendido &&
                                !row.faltou &&
                                (() => {
                                  const presenca = getClientePresenca(
                                    row.idCliente,
                                  );
                                  return presenca ? (
                                    <div
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "8px",
                                      }}
                                    >
                                      <span className="badge-horario">
                                        {formatarHorario(
                                          presenca.horarioChegada,
                                        )}
                                      </span>
                                      <button
                                        className="marcacaoPresencaBtn marcacaoPresencaBtn--saiu"
                                        onClick={handleSaiu.bind(
                                          null,
                                          row.idCliente,
                                        )}
                                      >
                                        Saiu
                                      </button>
                                    </div>
                                  ) : (
                                    <button
                                      className="marcacaoPresencaBtn marcacaoPresencaBtn--chegou"
                                      onClick={handleAguardando.bind(
                                        null,
                                        row.idCliente,
                                      )}
                                    >
                                      Chegou
                                    </button>
                                  );
                                })()}
                            </>
                          ) : null}
                          {/* Marcar falta é um ato do balcão onde a pessoa devia
                              ter comparecido. Estava FORA da guarda acima — a
                              secretária de um balcão marcava faltas do outro. */}
                          {podeAlterarRegisto(row.estabelecimento, auth) &&
                            !row.atendido &&
                            !row.faltou &&
                            !getClientePresenca(row.idCliente) && (
                              <button
                                className="faltouButton"
                                onClick={abrirDialogoMotivoFalta.bind(
                                  null,
                                  row.id,
                                )}
                              >
                                Faltou
                              </button>
                            )}
                        </>
                      )}
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      )}
      {marcacoes && marcacoes.length === 0 && (
        <span className="nenhumProcedimentoMsg">
          Nenhum procedimento por mostrar
        </span>
      )}

      {/* Confirmação de envio de SMS para todos */}
      <Dialog
        open={SMS_ATIVO && confirmacaoSmsDialogOpen}
        onClose={() => setConfirmacaoSmsDialogOpen(false)}
        aria-labelledby="confirmacao-sms-dialog-title"
      >
        <DialogTitle id="confirmacao-sms-dialog-title">
          Enviar SMS para todos
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            Vai enviar SMS para {pendentesCount} agendamento
            {pendentesCount !== 1 ? "s" : ""} pendente
            {pendentesCount !== 1 ? "s" : ""}. Confirma?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setConfirmacaoSmsDialogOpen(false)}>
            Cancelar
          </Button>
          <Button onClick={enviarSmsTodos} variant="contained" color="primary">
            Confirmar
          </Button>
        </DialogActions>
      </Dialog>

      {/* Modal para o motivo da falta com formulário */}
      <Dialog
        open={motivoFaltaDialogOpen}
        onClose={fecharDialogoMotivoFalta}
        aria-labelledby="motivo-falta-dialog-title"
      >
        <form onSubmit={submeterFormularioFalta}>
          <DialogTitle id="motivo-falta-dialog-title">
            {"Registrar motivo da falta"}
          </DialogTitle>
          <DialogContent>
            <DialogContentText style={{ marginBottom: "20px" }}>
              Selecione o motivo da falta do paciente para registro no sistema.
            </DialogContentText>

            <FormControl fullWidth required style={{ marginBottom: "20px" }}>
              <InputLabel id="motivo-falta-tipo-label">
                Motivo da Falta
              </InputLabel>
              <Select
                labelId="motivo-falta-tipo-label"
                id="motivoFaltaTipo"
                name="motivoFaltaTipo"
                label="Motivo da Falta"
                defaultValue=""
              >
                {MOTIVOS_FALTA.map((motivo) => (
                  <MenuItem key={motivo} value={motivo}>
                    {MOTIVOS_FALTA_LEGIVEL[motivo]}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <TextareaAutosize
              aria-label="detalhes da falta"
              name="motivoFaltaDetalhes"
              minRows={3}
              placeholder="Detalhes adicionais (opcional)"
              style={{ width: "100%", padding: "8px", boxSizing: "border-box" }}
            />
          </DialogContent>
          <DialogActions>
            <Button
              onClick={fecharDialogoMotivoFalta}
              type="button"
              color="primary"
            >
              Cancelar
            </Button>
            <Button type="submit" color="error" autoFocus>
              Confirmar Falta
            </Button>
          </DialogActions>
        </form>
      </Dialog>

      {/* Modal para escolher se imprime com ou sem observações */}
      <Dialog
        open={imprimirDialogOpen}
        onClose={() => setImprimirDialogOpen(false)}
        aria-labelledby="imprimir-dialog-title"
      >
        <DialogTitle id="imprimir-dialog-title">
          Opções de Impressão
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            Deseja incluir as observações na impressão?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setImprimirDialogOpen(false)}>Cancelar</Button>
          <Button onClick={() => confirmarImpressao(false)} color="primary">
            Sem Observações
          </Button>
          <Button
            onClick={() => confirmarImpressao(true)}
            color="primary"
            variant="contained"
          >
            Com Observações
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default MarcacoesTratamentoSecretaria;
